import { render, staticRenderFns } from "./SubelementShowDetailsTab.vue?vue&type=template&id=42c89eb8"
import script from "./SubelementShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./SubelementShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports